/**
 * BookManagement object represents book management-related API endpoints and their methods.
 */
const BookManagement = {
  /**
   * Endpoint for retrieving all book.
   * @memberof BookManagement
   * @type {object}
   * @property {string} url - The URL for retrieving all book.
   * @property {string} method - The HTTP method for retrieving all book (GET).
   */
  getBookList: {
    url: "/book",
    method: "GET",
  },

  /**
   * Endpoint for adding a book.
   * @memberof BookManagement
   * @type {object}
   * @property {string} url - The URL for adding an book.
   * @property {string} method - The HTTP method for adding an book (POST).
   */

  addBook: {
    url: "/book",
    method: "POST",
  },

  /**
   * Endpoint for deleting a specific Book by ID.
   * @memberof BookManagement
   * @function deleteBookById
   * @param {string} id - The ID of the Book to be deleted.
   * @returns {object} The endpoint object containing URL and method.
   */
  deleteBookById: (id) => ({
    url: `/Book/${id}`,
    method: "DELETE",
  }),

  /**
   * Endpoint for retrieving a specific book by ID.
   * @memberof BookManagement
   * @function getSingleBookById
   * @param {string} id - The ID of the book to retrieve.
   * @returns {object} The endpoint object containing URL and method.
   */
  getSingleBookById: (id) => ({
    url: `/book/${id}`,
    method: "GET",
  }),

  /**
   * Endpoint for updating a specific Book by ID.
   * @memberof BookManagement
   * @function updateCategory
   * @param {string} id - The ID of the Book to update.
   * @returns {object} The endpoint object containing URL and method.
   */
  updateBook: (id) => ({
    url: `/book/${id}`,
    method: "PUT",
  }),

  /**
   * Endpoint for updating a specific Book status by ID.
   * @memberof BookManagement
   * @function updateBook
   * @param {string} id - The ID of the Book to update status.
   * @returns {object} The endpoint object containing URL and method.
   */
  updateBookStatus: (id) => ({
    url: `/Book/${id}`,
    method: "PATCH",
  }),

  /**
   * Endpoint for updating a specific Book summary status by ID.
   * @memberof BookManagement
   * @function updateBook
   * @param {string} id - The ID of the Book to update summary status.
   * @returns {object} The endpoint object containing URL and method.
   */
  updateBookAcceptRejectStatus: (id, status) => ({
    url: `/book/${id}/summary/${status}`,
    method: "PATCH",
  }),

  /**
   * Endpoint for generating a summary for a specific Book by ID.
   * @memberof BookManagement
   * @function generateSummary
   * @param {string} id - The ID of the Book for which the summary needs to be generated.
   * @returns {object} The endpoint object containing URL and method.
   */
  generateSummary: (id) => ({
    url: `/book/${id}/generate-summary`,
    method: "GET",
  }),

  /**
   * Endpoint for getting list of book request.
   * @memberof BookManagement
   * @object bookRequest
   * @returns {object} The endpoint object containing URL and method.
   */
  getBookRequest: {
    url: `/book-request`,
    method: "GET",
  },
};

// Export the BookManagement object for use in other modules
export default BookManagement;
